import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button'
import { NbActionsModule, NbButtonModule, NbContextMenuModule, NbIconModule, NbLayoutModule, NbMenuModule, NbSidebarModule, NbUserModule } from '@nebular/theme';
import { ExternalComponent } from './external.component';
import { ExternalRoutingModule } from './external-routing.module';
import { SelectModule } from 'src/app/filtros/components/select/select.module';
import { NbSecurityModule } from '@nebular/security';

@NgModule({
  declarations: [
    ExternalComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    NbLayoutModule,
    NbSidebarModule,
    NbButtonModule,
    NbMenuModule,
    ExternalRoutingModule,
    SelectModule,
    NbUserModule,
    NbActionsModule,
    NbContextMenuModule,
    NbSecurityModule,
    NbIconModule
  ],
  exports: [ExternalComponent]
})
export class ExternalModule { }
